export default "__VITE_ASSET__DcvVDcTd__"